import React, {useState} from 'react';
import './planBusiness.scss';
import {CourseCard, CourseCardProps} from "../../../../components/course-card/CourseCard";
import PLAN_IMAGE1 from "../../../../assets/dashboard/planning_image.svg";
import {Button} from "../../../../components";

const PlanBusiness = () => {

    const [courses] = useState<CourseCardProps[]>([
        {
            image: PLAN_IMAGE1,
            heading: "Business Planning checklist",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: false,
            link: ""
        },
        {
            image: PLAN_IMAGE1,
            heading: "How to Write a Business Plan",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: true,
            link: ""
        },
        {
            image: PLAN_IMAGE1,
            heading: "Market Research & Analysis",
            description: "What better way to increase your knowledge than. What better way to increase your knowledge than.",
            isDone: false,
            link: ""
        },
    ])
    return (
        <div className={'plan-business'}>
            <div className={'plan-business_header'}>
                <div className={'plan-business_header_left'}>
                    <h1>Plan Business</h1>
                    <p>Planning a business has never been easier. With our help, you can smoothly transition through the
                        planning stages in order to get your business started. <br/><br/>Get started by going through
                        the
                        available courses below.</p>
                    <Button text={'Schedule A  Meeting'} type='primary'/>
                </div>
                <div className={'plan-business_header_right'}>
                    <img src={PLAN_IMAGE1} alt=""/>
                </div>
            </div>
            <div className={'plan-business_courses'}>
                <div className={'plan-business_courses_top'}>
                    <h1>Courses</h1>
                </div>
                <div className={'plan-business_courses_bottom'}>
                    {courses.map(({image, heading, description, isDone, link}) => (
                        <CourseCard image={image} heading={heading} description={description} isDone={isDone}
                                    link={link}/>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PlanBusiness;
